<template>
    <div>
        <b-row>
            <b-col sm="8">
                <h5 class="heading-1 mb-4">
                    <span>Ação</span>
                </h5>
            </b-col>
            <b-col sm="4">
                <b-button
                    class="float-right"
                    variant="warning"
                    @click="voltarAcao()">
                    <i class="fa fa-history"></i> 
                    Voltar as ações
                </b-button>
            </b-col>
        </b-row>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-alert show>
            <b-row>
                <b-col>
                    Nome da ação:
                    <strong>
                        {{ acao.nomeAcao }}
                    </strong>
                    <br/>
                    Vigência:
                    <strong>
                        {{ acao.vigencia }}
                    </strong>
                    <br/>
                    Unidade:
                    <strong>
                        {{ acao.nomeUnidade }}
                    </strong>
                </b-col>
            </b-row>
        </b-alert>

        <b-row>
            <b-col>
                <h5 class="heading-1 mb-4">
                    <span>Metas</span>
                </h5>
            </b-col>
        </b-row>
        <metas-tabela
            :acaoMetas="acaoMetas"
            :acao="acao"
            :dataServicos="dataServicos"
            @atualizarMeta="atualizarMeta($event)"
            @atualizarErros="atualizarErros($event)">
            <template slot="botoes"> </template>
        </metas-tabela>
    </div>
</template>

<script>
import MetasTabela from './MetasTabela'

export default {
    components: {
        MetasTabela,
    },

    props: {
        pleito: {
            type: Object,
            default: () => {}
        },

        acao: {
            type: Object,
            default: () => ({})
        },

        acaoMetas: {
            type: Array,
            default: () => []
        },

        dataServicos: {
            type: Object
        },
    },

    data() {
        return {
            erros: [],
        }
    },

    methods: {
        voltarAcao() {
            this.$emit('voltarAcao')
        },

        atualizarMetas() {
            this.$store.dispatch('addRequest')
            this.dataServicos.obterMetasPorAcao(this.acao.acaoId)
                .then(response => {
                if (response) {
                    if (response.success) {
                        this.metas = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter as metas da ação.',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        atualizarErros(eventos) {
            this.erros = eventos;
        },
    },
}
</script>
